import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ErrorService } from './error.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
})
export class ErrorReportingModule {
  static forRoot(): ModuleWithProviders<ErrorReportingModule> {
    return {
      ngModule: ErrorReportingModule,
      providers: [ErrorService],
    };
  }
}
